/**
 * InviteList — shows pending and accepted invites with revoke action.
 *
 * Props:
 *   invites    — [{ id, email, status, invited_at, seat_types: {name} }]
 *   dark       — boolean
 *   onRevoke(inviteId) — called when an invite is revoked
 */

export default function InviteList({ invites, dark, onRevoke, onResend }) {
  const textPrim  = dark ? 'rgba(207,226,232,0.92)' : '#07272D'
  const textMuted = dark ? 'rgba(91,132,148,0.80)'  : 'rgba(7,39,45,0.50)'
  const rowBorder = dark ? 'rgba(255,255,255,0.06)' : 'rgba(7,39,45,0.07)'

  if (!invites.length) {
    return (
      <div style={{ padding: '16px 20px', fontFamily: '"DM Sans", sans-serif', fontSize: 13, color: textMuted }}>
        No invites yet.
      </div>
    )
  }

  function fmtDate(iso) {
    if (!iso) return ''
    const d = new Date(iso)
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
  }

  return (
    <div>
      {/* Column headers */}
      <div style={{
        display: 'grid', gridTemplateColumns: '1fr 120px 120px 160px',
        padding: '8px 20px', gap: 12,
        borderBottom: `0.5px solid ${rowBorder}`,
      }}>
        {['Email', 'Seat', 'Invited', ''].map((h, i) => (
          <div key={i} style={{ fontFamily: '"DM Mono", monospace', fontSize: 10, color: textMuted, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
            {h}
          </div>
        ))}
      </div>

      {invites.map(inv => {
        const isPending = inv.status === 'pending'
        const actionBtn = {
          fontFamily: '"DM Sans", sans-serif', fontSize: 12,
          background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px',
        }
        return (
          <div
            key={inv.id}
            style={{
              display: 'grid', gridTemplateColumns: '1fr 120px 120px 160px',
              alignItems: 'center', padding: '10px 20px', gap: 12,
              borderBottom: `0.5px solid ${rowBorder}`,
              opacity: isPending ? 1 : 0.55,
            }}
          >
            <div style={{ fontFamily: '"DM Sans", sans-serif', fontSize: 13, color: textPrim, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {inv.email}
            </div>
            <div style={{ fontFamily: '"DM Sans", sans-serif', fontSize: 12, color: textMuted }}>
              {inv.seat_types?.name || '—'}
            </div>
            <div style={{ fontFamily: '"DM Mono", monospace', fontSize: 11, color: textMuted }}>
              {fmtDate(inv.invited_at)}
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', alignItems: 'center' }}>
              {isPending ? (
                <>
                  {onResend && (
                    <button onClick={() => onResend(inv)} style={{ ...actionBtn, color: '#1D9E75' }} title="Resend invite">
                      Resend
                    </button>
                  )}
                  <button onClick={() => onRevoke(inv.id)} style={{ ...actionBtn, color: 'rgba(192,57,43,0.75)' }} title="Revoke invite">
                    Revoke
                  </button>
                </>
              ) : (
                <span style={{ fontFamily: '"DM Sans", sans-serif', fontSize: 11, color: '#1D9E75' }}>
                  Accepted
                </span>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}
